import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router'

import Banner from '@/components/banners/Banner'
import { Button } from '@/components/ui/button'
import { faExclamationTriangle } from '@/lib/fontAwesomePro/solid'
import { NylasInvalidGrantNotification } from '@/types/entities'

interface Props {
  notification: NylasInvalidGrantNotification
}

const NylasInvalidGrantBanner: React.FC<Props> = ({ notification }) => {
  return (
    <Banner variant="danger">
      <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" />

      {notification.message}

      <Button variant="outline-secondary" asChild className="ml-2">
        <Link to={notification.actionLink}>{notification.actionText}</Link>
      </Button>
    </Banner>
  )
}

export default NylasInvalidGrantBanner
